/**
 * Roles map to permissions here and nowhere else (ARCHITECTURE.md §4.1).
 * A helper can take items in, photograph them and print labels, but sees no
 * money beyond an item's own prices. A member does everything except billing
 * and membership. Admins and owners run the workspace.
 */
export const ROLES = ["owner", "admin", "member", "helper"] as const;
export type Role = (typeof ROLES)[number];

export const PERMISSIONS = [
  "items.read",
  "items.write",
  "items.delete",
  "photos.write",
  "labels.print",
  "listings.write",
  "sales.write",
  "finance.read",
  "settings.write",
  "members.manage",
  "workspace.manage",
  "billing.manage",
] as const;
export type Permission = (typeof PERMISSIONS)[number];

const HELPER: Permission[] = ["items.read", "items.write", "photos.write", "labels.print"];
const MEMBER: Permission[] = [...HELPER, "items.delete", "listings.write", "sales.write", "finance.read", "settings.write"];
const ADMIN: Permission[] = [...MEMBER, "members.manage", "workspace.manage"];
const OWNER: Permission[] = [...ADMIN, "billing.manage"];

const GRANTS: Record<Role, ReadonlySet<Permission>> = {
  helper: new Set(HELPER),
  member: new Set(MEMBER),
  admin: new Set(ADMIN),
  owner: new Set(OWNER),
};

export function can(role: Role, permission: Permission): boolean {
  return GRANTS[role].has(permission);
}

export function permissionsOf(role: Role): Permission[] {
  return [...GRANTS[role]];
}
